export default __webpack_public_path__ + "static/media/wetFood.cb671a1f.png";